import ev from "../util/enumValue";

enum ProductState {
    UNAVAILABLE = ev('UNAVAILABLE', 0),
    AVAILABLE = ev('AVAILABLE', 1)
}

export default ProductState;
